import { FeatureFlag } from '@revelio/core';

import { useUnleashFlag } from '../../shared/unleash-flags/use-unleash-flag';
import {
  AISearchFilterBar,
  FilterBar,
  ScreenerV2FilterBar,
} from './components/FilterBar/FilterBar';
import { Header } from './components/Header';
import {
  usePageConfig,
  useTabContentConfig,
} from './components/PageConfigProvider/PageConfigProvider';
import { PageType } from './components/PageConfigProvider/types';
import { shouldShowAiSearchForPage } from './filters/ai-search/shouldShowAiSearchForPage';
import { isScreenerV2Page } from './utils/routing-helpers';

export const CustomDashPageSpecificWrappers = ({
  children,
}: React.PropsWithChildren) => {
  const { config } = usePageConfig();
  const { config: tabContentConfig } = useTabContentConfig();
  const revelioPageId = config.revelioPageId;
  const isReportPage = config.type === PageType.REPORT;
  const isScreenerPage = isScreenerV2Page(revelioPageId);
  const isAiSearchWiderDashboardEnabled = useUnleashFlag(
    FeatureFlag.AiSearchWiderDashboard
  );

  const shouldShowAiSearch = shouldShowAiSearchForPage({
    pageType: config.type,
    revelioPageId,
    primaryFilterId: tabContentConfig.primaryFilter?.id,
    isAiSearchWiderDashboardEnabled,
  });

  if (isReportPage) {
    return (
      <>
        <Header isReportPage={true} />
        {children}
      </>
    );
  }

  const filterBar = (() => {
    if (shouldShowAiSearch) {
      return <AISearchFilterBar hidePrimaryFilterBar={isScreenerPage} />;
    }
    if (isScreenerPage) {
      return <ScreenerV2FilterBar />;
    }

    return <FilterBar />;
  })();

  return (
    <>
      <Header isReportPage={false} />
      {filterBar}
      {children}
    </>
  );
};
